import { render, staticRenderFns } from "./TypeDocument.vue?vue&type=template&id=64ea55b1&scoped=true"
import script from "./TypeDocument.vue?vue&type=script&lang=js"
export * from "./TypeDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea55b1",
  null
  
)

export default component.exports